module.exports = __webpack_public_path__ + "static/media/track-channel-measurement-graphics.2eb43fb3.png";